import Table from "react-bootstrap/Table";
import _ from "lodash";
import * as reportSelectors from "../../../../selectors/report";
import EmptyItemView from "../../../../components/EmptyItemView";
import LoadingOverlay from "../../../../components/LoadingOverlay";
import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSort } from "@fortawesome/free-solid-svg-icons";
import Helper from "../../../../utils/Helper";
import Constants from "../../../../constants";
function ReportItemTable({ data, loading }) {
  const [transactionDateOrderBy, setTransactionDateOrderBy] = useState(false);
  const [stockNameOrderBy, setStockNameOrderBy] = useState(null);

  const orderByData = Helper.orderByData(data,transactionDateOrderBy,stockNameOrderBy)

  return (
    <Table responsive="xxl">
      {!loading && !_.isEmpty(data) ? (
        <thead>
        <tr className={"custom-table-setoff-styled"}>
          <th style={{ minWidth: 120,maxWidth: 120 }}>
            <div
              className="pointer"
              onClick={() =>{
                setStockNameOrderBy(null);
                setTransactionDateOrderBy((prev) => {
                  return !prev;
                })
              }
              }
            >
              Date
              <FontAwesomeIcon
                className="mx-2"
                icon={faSort}
              ></FontAwesomeIcon>
            </div>
          </th>
          <th style={{minWidth: "150px", maxWidth: "150px"}}>Reference No</th>
            <th style={{minWidth: "100px", maxWidth: "100px"}}>Stock Code</th>
            <th style={{minWidth: "140px", maxWidth: "140px"}}> <div
              className="pointer"
              onClick={() => {
                setTransactionDateOrderBy(false);
                setStockNameOrderBy((prev) => {
                  if (prev === Constants.ORDER_BY_ASC) {
                    return Constants.ORDER_BY_DESC;
                  }
                  if (prev === Constants.ORDER_BY_DESC) {
                    return Constants.ORDER_BY_ASC;
                  }
                  return Constants.ORDER_BY_ASC;
                });
              }}
            >
              Stock Name
              <FontAwesomeIcon
                className="mx-2"
                icon={faSort}
              ></FontAwesomeIcon>
            </div></th>
            <th style={{minWidth: "100px", maxWidth: "100px"}}>Quantity</th>
            <th style={{minWidth: "100px", maxWidth: "100px"}}>Price</th>
            <th style={{minWidth: "100px", maxWidth: "100px"}}>Brokerage Rate</th>
            <th style={{minWidth: "100px", maxWidth: "100px"}}>Brokerage Amount</th>
            <th style={{minWidth: "100px", maxWidth: "100px"}}>Exchange Rate</th>
            <th style={{minWidth: "100px", maxWidth: "100px"}}>Foreign Charges</th>
            <th style={{minWidth: "100px", maxWidth: "100px"}}>Clearing Fee</th>
            <th style={{minWidth: "100px", maxWidth: "100px"}}>Stamp Duty</th>
            <th style={{minWidth: "100px", maxWidth: "100px"}}>SST Amount</th>
            <th style={{minWidth: "120px", maxWidth: "120px"}}>Net Amount</th>
        </tr>
        </thead>
      ) : (
        false
      )}
      <tbody>
        {!_.isEmpty(orderByData) && !loading ? (
          _.map(orderByData, (item, index) => {
            const stockCode = reportSelectors.getReportStockCode(item);
            const stockName = reportSelectors.getReportStockName(item);
            const transactionQuantity = reportSelectors.getReportTransactionQuantity(item);
            const transactionPrice = reportSelectors.getReportTransactionPrice(item);
            const transactionDate = reportSelectors.getReportTransactionDate(item);
            const contractReference = reportSelectors.getReportContractReference(item);
            const exchangeRate = reportSelectors.getReportExchangeRate(item);
            const foreignCharges = reportSelectors.getReportForeignCharges(item);
            const brokerageAmount = reportSelectors.getReportBrokerageAmount(item);
            const brokerageRate = reportSelectors.getReportBrokerageRate(item);
            const clearingFee = reportSelectors.getReportClearingFee(item);
            const sstAmount = reportSelectors.getReportSSTAmount(item);
            const stampDuty = reportSelectors.getReportStampDuty(item);
            const netAmount = reportSelectors.getReportNetAmount(item);
            return (
                <tr key={index}>
                    <td style={{minWidth: "120px", maxWidth: "120px"}}>{transactionDate}</td>
                    <td style={{minWidth: "150px", maxWidth: "150px"}}>{contractReference}</td>
                    <td style={{minWidth: "100px", maxWidth: "100px"}}>{stockCode}</td>
                    <td style={{minWidth: "140px", maxWidth: "140px"}}>{stockName}</td>
                    <td style={{minWidth: "100px", maxWidth: "100px"}}>{transactionQuantity}</td>
                    <td style={{minWidth: "100px", maxWidth: "100px"}}>{transactionPrice}</td>
                    <td style={{minWidth: "100px", maxWidth: "100px"}}>{brokerageRate}</td>
                    <td style={{minWidth: "100px", maxWidth: "100px"}}>{brokerageAmount}</td>
                    <td style={{minWidth: "100px", maxWidth: "100px"}}>{exchangeRate}</td>
                    <td style={{minWidth: "100px", maxWidth: "100px"}}>{foreignCharges}</td>
                    <td style={{minWidth: "100px", maxWidth: "100px"}}>{clearingFee}</td>
                    <td style={{minWidth: "100px", maxWidth: "100px"}}>{stampDuty}</td>
                    <td style={{minWidth: "100px", maxWidth: "100px"}}>{sstAmount}</td>
                    <td style={{minWidth: "120px", maxWidth: "120px"}}>{netAmount}</td>
                </tr>
            );
          })
        ) : (
            <tr>
                <td colSpan={14}>
                    <EmptyItemView/>
                    <LoadingOverlay loading={loading}></LoadingOverlay>
                </td>
            </tr>
        )}
      </tbody>
    </Table>
  );
}

export default ReportItemTable;
